export default "__VITE_ASSET__DooKr9Zf__";